import { AppFacadeService } from '@smarsh-cyber/app-state';
import { BFF_BASE_URL } from '../../app.constants';

export function jwtOptionsFactory(appFacadeService: AppFacadeService) {
  const bffURL = new URL(BFF_BASE_URL);
  return {
    tokenGetter: () => {
      return appFacadeService.$userToken()?.authToken?.accessToken;
    },
    allowedDomains: [bffURL?.host]
  };
}
